/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/26
 * Time: 10:22
 */
<template>
  <div id='video-part'>
    <div class="video-container-hide" :class="{ 'video-container-show': visible, 'video-container-mobile': ifMobileVisible, 'video-container-hide-Mac': ifMacVisible }">
      <div class="video-body">
        <a class="video-close" @click="hideVideoFrame"></a>
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/MZU3yFhbro4?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-part',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      ifMobileVisible: false,
      ifMacVisible: false
    }
  },
  components: {},
  methods: {
    init () {
      let H = document.body.clientHeight
      if (!this.$lib.IsPC()) {
        this.ifMobileVisible = true
      } else if (this.$lib.IsPC() && H < 900) {
        this.ifMacVisible = true
      }
    },
    hideVideoFrame () {
      this.$emit('onVideoVisible')
    },
    lockScroll () {
      let videoContainer = document.getElementById('video-part')
      videoContainer.addEventListener('mousewheel', function (e) {
        e.preventDefault()
        e.stopPropagation()
      })
      videoContainer.addEventListener('touchmove', function (e) {
        e.preventDefault()
        e.stopPropagation()
      })
    }
  },
  mounted () {
    // video mounted
    this.init()
    this.lockScroll()
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
#video-part {
  //begin you code
  .video-container-hide {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    opacity: 0;
    display: none;
    background: rgba(0,0,0,.5);
    transition: all .5s;
    .video-body {
      width: 1000px;
      height: 600px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .video-close {
        position: absolute;
        top: -50px;
        right: 0;
        width: 50px;
        height: 50px;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
  }
  .video-container-hide-Mac {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    opacity: 0;
    display: none;
    background: rgba(0,0,0,.5);
    transition: all .5s;
    .video-body {
      width: 1000px;
      height: 600px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(.7);
      .video-close {
        position: absolute;
        top: -50px;
        right: 0;
        width: 50px;
        height: 50px;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
  }
  .video-container-mobile {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    opacity: 0;
    display: none;
    background: rgba(0,0,0,.5);
    transition: all .5s;
    .video-body {
      width: 7rem;
      height: 4.5rem;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .video-close {
        position: absolute;
        top: -.50rem;
        right: 0;
        width: .50rem;
        height: .50rem;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
  }
  .video-container-show {
    opacity: 1;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/index/video.vue